import {createActions} from 'client/framework';

const normalActions = ['SET_ACTIVE_ASSIGNMENT', 'SET_ACTIVE_STUDENT'];

export default createActions(null, normalActions);
